// src/components/Layout.js
import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';
import ThemeSwitcher from './ThemeSwitcher';

const NAV = [
  {
    section: 'Overview',
    links: [
      { to: '/dashboard', icon: '⬛', label: 'Dashboard' },
    ]
  },
  {
    section: 'Management',
    links: [
      { to: '/students', icon: '👥', label: 'Students' },
      { to: '/devices',  icon: '📱', label: 'Devices' },
    ]
  },
  {
    section: 'Network',
    links: [
      { to: '/radius', icon: '📡', label: 'FreeRADIUS' },
    ]
  },
  {
    section: 'Intelligence',
    links: [
      { to: '/ml',      icon: '🧠', label: 'ML Insights' },
      { to: '/reports', icon: '📊', label: 'Reports' },
    ]
  },
  {
    section: 'System',
    links: [
      { to: '/settings', icon: '⚙️',  label: 'Settings' },
    ]
  }
];

export default function Layout() {
  const { admin, logout } = useAuthStore();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Logged out');
    navigate('/login');
  };

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="layout">
      {/* Mobile overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={closeSidebar} />}

      <aside className={`sidebar${sidebarOpen ? ' sidebar-open' : ''}`}>
        <div className="sidebar-logo">
          <img src="/kcmcu-logo.png" alt="KCMC University" />
          <div>
            <h1>RADIUS MGR</h1>
            <span>Device Access Manager</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(section => (
            <div className="nav-section" key={section.section}>
              <div className="nav-section-title">{section.section}</div>
              {section.links.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                  onClick={closeSidebar}
                >
                  <span className="icon">{link.icon}</span>
                  {link.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <strong>{admin?.fullName || admin?.username}</strong>
          <span style={{ textTransform: 'capitalize', marginBottom: 8, display: 'block' }}>
            {admin?.role}
          </span>
          <button className="btn btn-ghost btn-sm" onClick={handleLogout} style={{ padding: '4px 0', width: '100%', justifyContent: 'flex-start' }}>
            ↩ Logout
          </button>
        </div>
      </aside>

      <main className="main">
        <div className="topbar">
          <button className="hamburger" onClick={() => setSidebarOpen(s => !s)} aria-label="Toggle menu">
            <span /><span /><span />
          </button>
          <div className="topbar-title">RADIUS Manager</div>
          <div className="topbar-actions">
            <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)' }}>{admin?.username}</span>
            <ThemeSwitcher />
          </div>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
